var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChattingActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.249878C4.0858 0.249919 3.75004 0.585682 3.75 0.999878V3.24988H1.5C1.0858 3.24992 0.750041 3.58568 0.75 3.99988V15.9999C0.750041 16.4141 1.0858 16.7498 1.5 16.7499H3V18.9999C2.99974 19.629 3.72754 19.9789 4.21875 19.5858L7.76367 16.7499H19.5C19.9142 16.7498 20.25 16.4141 20.25 15.9999V15.2499H22.5C22.9142 15.2498 23.25 14.9141 23.25 14.4999V0.999878C23.25 0.585682 22.9142 0.249919 22.5 0.249878H4.5ZM5.25 1.74988H21.75V13.7499H20.25V3.99988C20.25 3.58568 19.9142 3.24992 19.5 3.24988H5.25V1.74988ZM2.25 4.74988H18.75V15.2499H7.5C7.32965 15.2498 7.16434 15.3076 7.03125 15.4139L4.5 17.4384V15.9999C4.49996 15.5857 4.1642 15.2499 3.75 15.2499H2.25V4.74988Z",
    fill: "#C3A981"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChattingActive);
export default __webpack_public_path__ + "static/media/ic-chatting-active.7ef5dc2bc66443a672d8e61e3cba4ffd.svg";
export { ForwardRef as ReactComponent };